import { http } from "../base";

export async function listKbWorkspaces_by_tenantId_username(tenantId, username) {

  console.log("listKbWorkspaces_by_tenantId_username",tenantId,username);
  const response = await http.get(
    `/aics/kb_workspace/find_by_tenant_username?tenantId=${tenantId}&userName=${username}`,    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
    console.log(response);
    // 统一处理响应格式
    if (response==null || response.status !== 200) {
      throw new Error(response.data.message || '获取员工列表失败');
    }
    return response.data;
  }

  export async function listKbWorkspaces_by_tenantId(tenantId) {

    console.log("listKbWorkspaces_by_tenantId",tenantId);
    const response = await http.get(
      `/aics/kb_workspace/find_by_tenant?tenantId=${tenantId}`,    {
        headers: { 'Content-Type': 'application/json' }
      }
    );
      console.log(response);
      // 统一处理响应格式
      if (response==null || response.status !== 200) {
        throw new Error(response.data.message || '获取员工列表失败');
      }
      return response.data;
    }

    export async function getKbWorkspaceDetails(slug) {
          console.log("getKbWorkspaceDetails",slug);
          const response = await http.get(
            `/aics/kb_workspace/${slug}`,
          );
            console.log(response);
            // 统一处理响应格式
            if (response==null || response.status !== 200) {
              throw new Error(response.data.message || '获取配置信息失败');
            }
            return response.data;
    }

        export async function getKbWorkspaceDocuments(slug) {
          console.log("getKbWorkspaceDocuments",slug);
          const response = await http.get(
            `/aics/kb_workspace/documents/${slug}`,
          );
            console.log(response);
            // 统一处理响应格式
            if (response==null || response.status !== 200) {
              throw new Error(response.data.message || '获取配置信息失败');
            }
            return response.data;
    }

  export async function createKbWorkspace(tenantId, data) {

    console.log("createKbWorkspace", tenantId, data);

    const response = await http.post(
      `/aics/kb_workspace/`,
      {
        'tenantId': tenantId,
        'name': data.name,
        'serviceTo': data.serviceTo
      },
      {
        headers: { 'Content-Type': 'application/json',
                    'X-Tenant-Id': tenantId  // 添加企业ID头
         }

      });
      console.log(response.data);
      // 统一处理响应格式
      if (response.data==null || response.data.code !== 200) {
        throw new Error(response.data.message || '创建员工失败');
      }
      return response.data;
    }

    export async function updateKbWorkspace(slug, data) {

      console.log("updateKbWorkspace", slug, data);

      const response = await http.put(
        `/aics/kb_workspace/${slug}`,
        {
          'name': data.name,
          'openAiTemp': data.openAiTemp
        },
        {
          headers: { 'Content-Type': 'application/json',
                    //  'X-Tenant-Id': tenantId  // 添加企业ID头
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '保存工作区配置信息失败');
        }
        return response.data;
      }

      export async function listEmployees_by_tenantId(tenantId) {

        console.log("listEmployees_by_tenantId",tenantId);
        const response = await http.post(
          `/tenant/listemployees`,
          {
            keyword: '',
            'tenantId': tenantId,
            'pageNo':0,
            'pageSize':10
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        );
          console.log(response);
          // 统一处理响应格式
          if (response==null || response.status !== 200) {
            throw new Error(response.data.message || '获取员工列表失败');
          }
          return response.data;
      }

      export async function grantKbWorkspaceToUser(tenantId,data) {

        console.log("grantKbWorkspaceToUser", data);

        const response = await http.post(
          `/aics/kb_workspace/grant`,
          data,
          {
            headers: { 'Content-Type': 'application/json',
                  'X-Tenant-Id': tenantId  // 添加企业ID头
             }

          });
          console.log(response.data);
          // 统一处理响应格式
          if (response.data==null || response.data.code !== 200) {
            throw new Error(response.data.message || '保存工作区配置信息失败');
          }
          return response.data;
        }

        export async function EmbeddingDoc(tenantId,doc_id, kb_workspace_slug){
        console.log("EmbeddingDoc", doc_id, kb_workspace_slug);

        const response = await http.post(
          `/aics/kb_workspace/embedding_doc`,
          {
            'doc_id': doc_id,
            'kb_workspace_slug': kb_workspace_slug
          },
          {
            headers: { 'Content-Type': 'application/json',
                  'X-Tenant-Id': tenantId  // 添加企业ID头
             }

          });
          console.log(response.data);
          return response;          
        }

        export async function remove_document_from_workspace(tenantId,doc_location, kb_workspace_slug){
        console.log("remove_document_from_workspace",tenantId, doc_location, kb_workspace_slug);

        const response = await http.post(
          `/aics/kb_workspace/remove_document_from_workspace`,
          {
            'doc_location': doc_location,
            'kb_workspace_slug': kb_workspace_slug
          },
          {
            headers: { 'Content-Type': 'application/json',
                  'X-Tenant-Id': tenantId  // 添加企业ID头
             }

          });
          console.log(response.data);
          // 统一处理响应格式
          if (response.data==null || response.data.code !== 200) {
            throw new Error(response.data.message || '嵌入知识库失败');
          }
          return response.data;          
        }
    export async function getUserPermission(username) {
          console.log("getUserPermission",username);
          const response = await http.get(
            `/aics/user_permission/${username}`,
          );
            console.log(response);
            // 统一处理响应格式
            if (response==null || response.status !== 200) {
              throw new Error(response.data.message || '获取配置信息失败');
            }
            return response.data;
    }   
    
   